<script lang="ts" setup>
import { ref } from 'vue';
import Menu from 'primevue/menu';
import Dialog from 'primevue/dialog';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';

const emit = defineEmits([EMIT.CANCEL, EMIT.SAVE, EMIT.CLOSE, EMIT.EDIT]);

const menu = ref();

const toggle = (event: Event): void => menu.value.toggle(event);

const visible = ref(false);

const openDeleteBuildingModal = () => {
  visible.value = true;
  menu.value.hide();
};

const openEditBuildingModal = () => {
  emit(EMIT.EDIT);
  menu.value.hide();
  visible.value = false;
};

const menuItems = (() => {
  return [
    {
      label: 'Edit Building',
      icon: {
        name: 'edit',
        styles: 'inline-block text-lg text-orange-500',
      },
      command: openEditBuildingModal,
      visible: can([PERMISSIONS.BUILDING_MANAGE]),
    },
    {
      label: 'Delete Building',
      icon: {
        name: 'delete',
        styles: 'inline-block text-lg text-red-500',
      },
      command: openDeleteBuildingModal,
      visible: can([PERMISSIONS.BUILDING_ASSIGN]),
    },
  ];
})();

function submit() {
  emit(EMIT.SAVE);
  visible.value = false;
}
</script>

<template>
  <div class="ml-3 cursor-pointer" @click="toggle">
    <Icon name="more_horiz" class="text-lg p-1" />
    <Menu id="overlay_menu" ref="menu" class="mt-2 ml-2 p-2" :model="menuItems" :popup="true">
      <template #item="{ item }: { item: any }">
        <div class="p-2">
          <a v-if="item.command">
            <Icon :name="item.icon?.name" :class="item.icon?.styles" />
            <span class="relative inline-block ml-2 text-sm text-800" v-text="item.label" />
          </a>
        </div>
      </template>
    </Menu>
  </div>
  <Dialog v-model:visible="visible" modal header="Delete Building" :closable="true" style="width: 500px">
    <p>Are you sure you want to delete this building?</p>
    <template #footer>
      <AppButton text="Cancel" type="secondary" @click="visible = false" />
      <AppButton text="Save" type="primary" @click="submit" />
    </template>
  </Dialog>
</template>
